import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const ADMIN_KEY = 'aim-admin-84deadf05b47284331cbf654'
const authHeaders = () => ({ 'X-Admin-Key': ADMIN_KEY })

// 复制文本（P2-C · 2026-09-16 小套）：微信单号/商户单号一键复制，供商户平台退款填单用
function copyText(t) {
  if (!t) return
  const done = () => alert('已复制：' + t)
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(t).then(done).catch(() => {})
  } else {
    const ta = document.createElement('textarea')
    ta.value = t
    document.body.appendChild(ta)
    ta.select()
    document.execCommand('copy')
    document.body.removeChild(ta)
    done()
  }
}
const shortNo = s => (s && String(s).length > 16 ? String(s).slice(0, 9) + '…' + String(s).slice(-6) : (s || '-'))

const API = VITE_API_BASE

const th = { padding: '12px 8px', textAlign: 'left', fontSize: 13, color: '#666', whiteSpace: 'nowrap' }
const td = { padding: '12px 8px', fontSize: 13, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }

export default function Orders() {
  const [orders, setOrders] = useState([])
  const [loading, setLoading] = useState(true)
  const [filter, setFilter] = useState('all')
  const [search, setSearch] = useState('')
  const [editingDelivery, setEditingDelivery] = useState(null) // { id, deliveryStatus, trackingNo }
  const [saving, setSaving] = useState(false)
  // 批量发货（P1-A · 2026-09-11）：选中 -> 粘贴/沿用单号 -> POST /orders/batch-ship
  const [selected, setSelected] = useState({}) // { [orderId]: true }
  const [batchOpen, setBatchOpen] = useState(false)
  const [batchMode, setBatchMode] = useState('ship') // ship=补录单号并发货 | tracking=仅更新运单号
  const [batchText, setBatchText] = useState('')
  const [batchRunning, setBatchRunning] = useState(false)
  const [batchResult, setBatchResult] = useState(null)
  const [refundingId, setRefundingId] = useState(null) // 微信退款进行中的订单ID
  // 智能粘贴发货（P1-S · 2026-09-16）：菜鸟原文 → 自动对单 → 人工确认 → 发货
  const [smartOpen, setSmartOpen] = useState(false)
  const [smartText, setSmartText] = useState('')
  const [smartPreview, setSmartPreview] = useState(null)
  const [smartLoading, setSmartLoading] = useState(false)
  const [smartError, setSmartError] = useState('')
  const [smartPicks, setSmartPicks] = useState({}) // idx -> { use, orderId, trackingNo }
  const [smartRunning, setSmartRunning] = useState(false)
  const [smartResult, setSmartResult] = useState(null)

  useEffect(() => {
    (async () => {
      try {
        let page = 1
        const all = []
        for (;;) {
          const res = await fetch(`${API}/orders?page=${page}&limit=100`, { headers: authHeaders() })
          const d = await res.json()
          if (!d.success) break
          all.push(...(d.data || []))
          const pg = d.pagination || {}
          if (!d.data || !d.data.length || page >= (pg.totalPages || 1)) break
          page += 1
        }
        setOrders(all)
      } catch (err) {
        console.error('获取订单失败', err)
      } finally {
        setLoading(false)
      }
    })()
  }, [])

  const matchTab = (o, key) => {
    if (key === 'all') return true
    if (key === 'pending_ship') return o.payment_status === 'paid' && (!o.delivery_status || o.delivery_status === 'pending')
    if (key === 'paid') return o.payment_status === 'paid'
    if (key === 'pending') return o.payment_status === 'unpaid'
    if (key === 'refunded') return o.payment_status === 'refunded'
    return o.status === key || o.delivery_status === key
  }
  const countFor = (key) => orders.reduce((n, o) => n + (matchTab(o, key) ? 1 : 0), 0)

  const filtered = orders.filter(o => {
    const matchFilter = matchTab(o, filter)

    const matchSearch = !search || 
      (o.customer_name && o.customer_name.includes(search)) || 
      (o.order_no && o.order_no.includes(search)) || 
      (o.product_name && o.product_name.includes(search)) ||
      (o.address && o.address.includes(search))
    return matchFilter && matchSearch
  })

  // ---------- 批量发货 ----------
  const allSelected = filtered.length > 0 && filtered.every(o => selected[o.id])
  const selectedIds = orders.filter(o => selected[o.id]).map(o => o.id)
  const selectedCount = selectedIds.length

  const toggleRow = (id) => setSelected(prev => ({ ...prev, [id]: !prev[id] }))
  const toggleAllFiltered = () => {
    const target = !allSelected
    setSelected(prev => {
      const next = { ...prev }
      filtered.forEach(o => { next[o.id] = target })
      return next
    })
  }

  // 解析粘贴文本：每行「订单号 快递单号（备注）」；单号取行内最长的数字/字母串，能容忍「183 中通一联1 79032...」这类夹杂备注的行
  const parseBatchText = (text) => {
    const map = {}
    const skippedLines = []
    text.split(/\r?\n/).forEach(line => {
      const t = line.trim()
      if (!t) return
      const parts = t.split(/[\s,，;；\t]+/)
      const id = (parts[0] || '').replace(/^#/, '')
      if (!/^\d{1,10}$/.test(id)) { skippedLines.push(t); return }
      let value = parts.slice(1).join(' ').trim()
      const tokens = value.match(/[A-Za-z0-9_-]{6,}/g)
      if (tokens && tokens.length) value = tokens.reduce((a, b) => (b.length > a.length ? b : a))
      if (value) map[id] = value
    })
    return { map, skippedLines }
  }

  const buildBatchPreview = () => {
    const { map, skippedLines } = parseBatchText(batchText)
    // 粘贴了单号的优先；没粘贴的沿用库中已有单号
    orders.forEach(o => {
      if (selected[o.id] && o.tracking_no && !map[String(o.id)]) map[String(o.id)] = o.tracking_no
    })
    const rows = selectedIds.map(id => {
      const o = orders.find(x => x.id === id)
      return {
        id,
        order_no: o && o.order_no,
        name: o && (o.customer_name || o.product_name),
        tracking: map[String(id)] || '',
        paid: !!(o && o.payment_status === 'paid')
      }
    })
    return { map, rows, skippedLines }
  }
  const batchPreview = batchOpen ? buildBatchPreview() : { map: {}, rows: [], skippedLines: [] }

  const runBatch = async () => {
    if (!selectedIds.length) return
    const { map, rows } = buildBatchPreview()
    const noTracking = rows.filter(r => !r.tracking).length
    const notPaid = rows.filter(r => !r.paid).length
    let msg = `确认对 ${rows.length} 笔选中订单执行「${batchMode === 'ship' ? '批量发货' : '批量更新运单号'}」？`
    if (noTracking) msg += `\n其中 ${noTracking} 笔无运单号（将自动跳过）`
    if (notPaid) msg += `\n其中 ${notPaid} 笔未支付（将自动跳过）`
    if (!confirm(msg)) return
    setBatchRunning(true)
    try {
      const res = await fetch(API + '/orders/batch-ship', {
        method: 'POST',
        headers: { ...authHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ids: selectedIds,
          trackingMap: map,
          remark: batchMode === 'ship' ? 'CMS后台批量发货' : 'CMS后台批量更新运单号'
        })
      })
      const data = await res.json()
      if (data.success) {
        const r = data.data || { shipped: [], skipped: [], failed: [] }
        setBatchResult(r)
        setOrders(prev => prev.map(o => {
          const hit = r.shipped.find(s => s.id === o.id)
          return hit ? { ...o, delivery_status: 'shipped', tracking_no: hit.tracking_no } : o
        }))
        setSelected({})
        setBatchText('')
      } else {
        alert('批量发货失败: ' + (data.error || '未知错误'))
      }
    } catch (e) {
      alert('批量发货失败: ' + e.message)
    } finally {
      setBatchRunning(false)
    }
  }

  // ---------- 智能粘贴发货（P1-S · 2026-09-16）----------
  const openSmart = () => {
    setSmartText(''); setSmartPreview(null); setSmartError(''); setSmartPicks({}); setSmartResult(null); setSmartOpen(true)
  }

  const runSmartPreview = async () => {
    if (!smartText.trim()) { setSmartError('请先粘贴菜鸟导出的收件人/物流原文'); return }
    setSmartLoading(true); setSmartError(''); setSmartPreview(null); setSmartPicks({})
    try {
      const res = await fetch(API + '/orders/smart-ship/preview', {
        method: 'POST', headers: { ...authHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ text: smartText })
      })
      const d = await res.json()
      if (d.success) {
        setSmartPreview(d.data)
        const picks = {}
        ;(d.data.entries || []).forEach(e => {
          picks[e.idx] = { use: e.match === 'matched', orderId: e.match === 'matched' ? e.order.id : '', trackingNo: e.trackingNo || '' }
        })
        setSmartPicks(picks)
      } else {
        setSmartError(d.error || '解析失败')
      }
    } catch (e) {
      setSmartError('网络错误: ' + e.message)
    } finally {
      setSmartLoading(false)
    }
  }

  const updatePick = (idx, field, value) =>
    setSmartPicks(prev => ({ ...prev, [idx]: { ...prev[idx], [field]: value } }))

  const smartReadyCount = () => {
    if (!smartPreview) return 0
    return smartPreview.entries.filter(e => {
      const p = smartPicks[e.idx]
      return p && p.use && p.orderId && String(p.trackingNo || '').trim()
    }).length
  }

  const runSmartApply = async () => {
    const items = (smartPreview.entries || []).map(e => {
      const p = smartPicks[e.idx]
      return (p && p.use && p.orderId) ? { orderId: parseInt(p.orderId), trackingNo: String(p.trackingNo || '').trim() } : null
    }).filter(Boolean).filter(it => it.trackingNo)
    if (!items.length) { alert('没有可执行的条目（需勾选 + 指定订单 + 有运单号）'); return }
    if (!confirm(`确认对 ${items.length} 笔订单执行智能发货？`)) return
    setSmartRunning(true)
    try {
      const res = await fetch(API + '/orders/smart-ship/apply', {
        method: 'POST', headers: { ...authHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ items, remark: 'CMS后台智能粘贴发货' })
      })
      const d = await res.json()
      if (d.success) {
        const r = d.data || { shipped: [], skipped: [], failed: [] }
        setSmartResult(r)
        setOrders(prev => prev.map(o => {
          const hit = r.shipped.find(s => s.id === o.id)
          return hit ? { ...o, delivery_status: 'shipped', tracking_no: hit.tracking_no } : o
        }))
      } else {
        alert('智能发货失败: ' + (d.error || '未知错误'))
      }
    } catch (e) {
      alert('智能发货失败: ' + e.message)
    } finally {
      setSmartRunning(false)
    }
  }

  const getStatusBadge = (order) => {
    const status = order.status
    const paymentStatus = order.payment_status
    const deliveryStatus = order.delivery_status

    // 优先显示支付状态，再显示物流状态
    if (status === 'cancelled') return { bg: '#f5f5f5', color: '#999', text: '已取消' }
    if (paymentStatus === 'unpaid') return { bg: '#fffbe6', color: '#faad14', text: '待支付' }
    if (paymentStatus === 'refunded') return { bg: '#fff1f0', color: '#ff4d4f', text: '已退款' }
    
    // 已支付的订单显示物流状态
    if (paymentStatus === 'paid') {
      if (!deliveryStatus || deliveryStatus === 'pending') return { bg: '#e6f7ff', color: '#1890ff', text: '待发货' }
      if (deliveryStatus === 'shipped') return { bg: '#f6ffed', color: '#52c41a', text: '已发货' }
      if (deliveryStatus === 'delivering') return { bg: '#fff7e6', color: '#fa8c16', text: '运输中' }
      if (deliveryStatus === 'received') return { bg: '#f6ffed', color: '#52c41a', text: '已签收' }
    }
    if (paymentStatus === 'offline') return { bg: '#f5f5f5', color: '#999', text: '线下报名' }
    return { bg: '#f6ffed', color: '#52c41a', text: '已支付' }
  }

  const startEditDelivery = (order) => {
    setEditingDelivery({
      id: order.id,
      deliveryStatus: order.delivery_status || 'shipped',
      trackingNo: order.tracking_no || ''
    })
  }

  const updateDeliveryField = (field, value) => {
    setEditingDelivery(prev => ({ ...prev, [field]: value }))
  }

  const handleDeleteOrder = (order) => {
    if (!confirm('确定删除订单 #' + order.id + ' (' + (order.product_name || '') + ')？')) return
    fetch(API + '/orders/' + order.id, { method: 'DELETE', headers: authHeaders() })
      .then(r => r.json())
      .then(d => {
        if (d.success) {
          setOrders(orders.filter(o => o.id !== order.id))
        } else {
          alert('删除失败: ' + (d.error || '未知错误'))
        }
      })
      .catch(err => alert('网络错误'))
  }

  // 微信退款（P1-B · 2026-09-12 小套）：全额原路退回，仅已支付订单
  const handleRefund = async (order) => {
    if (order.payment_status !== 'paid') { alert('仅已支付订单可退款'); return }
    if (!confirm(`确认对订单 #${order.id}（${order.product_name || ''}）全额退款 ¥${order.price || 0}？\n将原路退回客户微信，不可撤销。`)) return
    const input = prompt('退款原因（记入订单日志）：', '客户申请退款')
    if (input === null) return
    const reason = input.trim() || '客户申请退款'
    setRefundingId(order.id)
    try {
      const res = await fetch(API + '/orders/' + order.id + '/refund', {
        method: 'POST',
        headers: { ...authHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ reason })
      })
      const data = await res.json()
      if (data.success) {
        alert(data.message || '退款成功')
        setOrders(prev => prev.map(o => o.id === order.id ? { ...o, payment_status: 'refunded', status: 'refunded' } : o))
      } else {
        alert('退款失败: ' + (data.error || '未知错误'))
      }
    } catch (e) {
      alert('退款失败: ' + e.message)
    } finally {
      setRefundingId(null)
    }
  }

  const saveDelivery = async () => {
    if (!editingDelivery) return
    setSaving(true)
    try {
      const res = await fetch(`${API}/orders/${editingDelivery.id}/status`, {
        method: 'PUT',
        headers: { ...authHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
          deliveryStatus: editingDelivery.deliveryStatus,
          trackingNo: editingDelivery.trackingNo,
          remark: 'CMS后台更新物流信息'
        })
      })
      const data = await res.json()
      if (data.success) {
        setOrders(prev => prev.map(o => 
          o.id === editingDelivery.id 
            ? { ...o, delivery_status: editingDelivery.deliveryStatus, tracking_no: editingDelivery.trackingNo }
            : o
        ))
        setEditingDelivery(null)
      } else {
        alert('保存失败: ' + (data.error || '未知错误'))
      }
    } catch (err) {
      alert('保存失败: ' + err.message)
    } finally {
      setSaving(false)
    }
  }

  const DELIVERY_STATUS_OPTIONS = [
    { value: 'shipped', label: '已发货' },
    { value: 'delivering', label: '运输中' },
    { value: 'received', label: '已签收' }
  ]

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>加载中...</div>

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>📋 订单管理</h2>

      <div style={{ display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' }}>
        {[
          { key: 'all', label: '全部' },
          { key: 'pending_ship', label: '待发货' },
          { key: 'shipped', label: '已发货' },
          { key: 'delivering', label: '运输中' },
          { key: 'received', label: '已签收' },
          { key: 'paid', label: '已支付' },
          { key: 'pending', label: '待支付' },
          { key: 'refunded', label: '已退款' },
          { key: 'cancelled', label: '已取消' },
        ].map(f => (
          <button key={f.key} onClick={() => setFilter(f.key)}
            style={{ padding: '6px 14px', border: 'none', borderRadius: 6, cursor: 'pointer',
              background: filter === f.key ? '#1890ff' : '#f5f5f5',
              color: filter === f.key ? '#fff' : '#666', fontSize: 13 }}>
            {f.label} {countFor(f.key)}
          </button>
        ))}
        <input type="text" placeholder="搜索订单号/产品/收货人..." value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ flex: 1, minWidth: 200, padding: '6px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 13 }} />
        <button onClick={openSmart}
          style={{ padding: '6px 14px', border: 'none', borderRadius: 6, cursor: 'pointer',
            background: '#722ed1', color: '#fff', fontSize: 13 }}>
          🪄 智能粘贴发货
        </button>
        <button onClick={() => { setBatchResult(null); setBatchOpen(true) }} disabled={selectedCount === 0}
          style={{ padding: '6px 14px', border: 'none', borderRadius: 6,
            cursor: selectedCount ? 'pointer' : 'not-allowed',
            background: selectedCount ? '#52c41a' : '#d9d9d9', color: '#fff', fontSize: 13 }}>
          🚚 批量发货 ({selectedCount})
        </button>
      </div>

      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        {filtered.length === 0 ? (
          <div style={{ padding: 60, textAlign: 'center', color: '#999' }}>暂无订单数据</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#fafafa' }}>
                <th style={{ ...th, width: 36 }}>
                  <input type="checkbox" checked={allSelected} onChange={toggleAllFiltered} title="全选当前筛选结果" />
                </th>
                <th style={th}>订单号</th>
<th style={th}>微信 / 商户单号</th>
                <th style={th}>产品</th>
                <th style={th}>金额</th>
                <th style={th}>收货人</th>
                <th style={th}>联系电话</th>
                <th style={th}>收货地址</th>
                <th style={th}>快递单号</th>
                <th style={th}>物流状态</th>
                <th style={th}>操作</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(o => {
                const badge = getStatusBadge(o)
                return (
                  <tr key={o.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ ...td, width: 36 }}>
                      <input type="checkbox" checked={!!selected[o.id]} onChange={() => toggleRow(o.id)} />
                    </td>
                    <td style={{ ...td, fontSize: 12, color: '#999' }}>{o.order_no || o.id}</td>
                    <td style={{ ...td, fontSize: 11 }}>
                      {(o.wx_trade_no || o.payment_no) ? (
                        <div style={{ lineHeight: 1.7 }}>
                          <div>
                            <span title={o.wx_trade_no || ''}>微信:{shortNo(o.wx_trade_no)}</span>
                            {o.wx_trade_no ? (
                              <button onClick={() => copyText(o.wx_trade_no)} style={{ marginLeft: 4, padding: '0 5px', fontSize: 10, border: '1px solid #d9d9d9', borderRadius: 3, background: '#fff', color: '#1890ff', cursor: 'pointer' }}>复制</button>
                            ) : null}
                          </div>
                          <div>
                            <span title={o.payment_no || ''}>商户:{shortNo(o.payment_no)}</span>
                            {o.payment_no ? (
                              <button onClick={() => copyText(o.payment_no)} style={{ marginLeft: 4, padding: '0 5px', fontSize: 10, border: '1px solid #d9d9d9', borderRadius: 3, background: '#fff', color: '#1890ff', cursor: 'pointer' }}>复制</button>
                            ) : null}
                          </div>
                        </div>
                      ) : '-'}
                    </td>
                    <td style={td}>{o.product_name || '-'}</td>
                    <td style={{ ...td, color: '#f5222d', fontWeight: 500 }}>¥{o.price || o.amount || 0}</td>
                    <td style={td}>{o.customer_name || '-'}</td>
                    <td style={td}>{o.customer_phone || '-'}</td>
                    <td style={{ ...td, maxWidth: 150 }}>{o.address || '-'}</td>
                    <td style={td}>{o.tracking_no || '-'}</td>
                    <td style={td}>
                      <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: badge.bg, color: badge.color }}>
                        {badge.text}
                      </span>
                    </td>
                    <td style={td}>
                      {o.address && o.payment_status === 'paid' && o.status !== 'cancelled' ? (
                        <button onClick={() => startEditDelivery(o)}
                          style={{ padding: '4px 10px', border: '1px solid #1890ff', borderRadius: 4, background: '#fff', color: '#1890ff', cursor: 'pointer', fontSize: 12 }}>
                          物流管理
                        </button>
                      ) : null}
                      {o.payment_status === 'paid' && o.status !== 'refunded' ? (
                        <button onClick={() => handleRefund(o)} disabled={refundingId === o.id}
                          style={{ padding: '4px 10px', border: '1px solid #fa8c16', borderRadius: 4, background: '#fff', color: '#fa8c16', cursor: 'pointer', fontSize: 12, marginLeft: 4 }}>
                          {refundingId === o.id ? '退款中…' : '退款'}
                        </button>
                      ) : null}
                      <button onClick={() => handleDeleteOrder(o)}
                        style={{ padding: '4px 10px', border: '1px solid #ff4d4f', borderRadius: 4, background: '#fff', color: '#ff4d4f', cursor: 'pointer', fontSize: 12, marginLeft: 4 }}>
                        删除
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        )}
      </div>

      {/* 批量发货弹窗 */}
      {batchOpen && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: 560, maxWidth: '92vw', maxHeight: '86vh', overflowY: 'auto' }}>
            {!batchResult ? (
              <>
                <h3 style={{ margin: '0 0 8px', fontSize: 16 }}>🚚 批量发货（已选 {selectedIds.length} 笔）</h3>
                <div style={{ fontSize: 12, color: '#999', marginBottom: 12 }}>
                  仅已支付订单会发货；无运单号的自动跳过并在结果里给出原因。两种模式都会把物流状态置为「已发货」。
                </div>
                <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
                  {[{ v: 'ship', t: '📦 补录单号并发货' }, { v: 'tracking', t: '✏️ 仅更新运单号' }].map(m => (
                    <button key={m.v} onClick={() => setBatchMode(m.v)}
                      style={{ padding: '6px 12px', borderRadius: 6, fontSize: 13,
                        border: '1px solid ' + (batchMode === m.v ? '#1890ff' : '#d9d9d9'),
                        background: batchMode === m.v ? '#e6f7ff' : '#fff',
                        color: batchMode === m.v ? '#1890ff' : '#666', cursor: 'pointer' }}>
                      {m.t}
                    </button>
                  ))}
                </div>
                <textarea value={batchText} onChange={e => setBatchText(e.target.value)} rows={5}
                  placeholder={'每行一笔：订单号 快递单号（单号可留空＝用系统里已录的）\n例：\n183 79032141575122\n184'}
                  style={{ width: '100%', boxSizing: 'border-box', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 13, fontFamily: 'monospace' }} />
                {batchPreview.skippedLines.length > 0 && (
                  <div style={{ marginTop: 8, fontSize: 12, color: '#fa8c16' }}>
                    ⚠️ 未识别行（将忽略）：{batchPreview.skippedLines.join('；')}
                  </div>
                )}
                {batchPreview.rows.length > 0 && (
                  <div style={{ marginTop: 12, border: '1px solid #f0f0f0', borderRadius: 6, maxHeight: 200, overflowY: 'auto' }}>
                    {batchPreview.rows.map(r => (
                      <div key={r.id} style={{ display: 'flex', justifyContent: 'space-between', gap: 12, padding: '6px 10px', borderBottom: '1px solid #f5f5f5', fontSize: 12 }}>
                        <span>#{r.id} {r.name || ''}</span>
                        <span style={{ color: !r.paid ? '#fa8c16' : (r.tracking ? '#52c41a' : '#faad14') }}>
                          {!r.paid ? '未支付·将跳过' : (r.tracking || '无单号·将跳过')}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
                <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 20 }}>
                  <button onClick={() => setBatchOpen(false)}
                    style={{ padding: '8px 20px', border: '1px solid #d9d9d9', borderRadius: 6, background: '#fff', cursor: 'pointer', fontSize: 14 }}>
                    取消
                  </button>
                  <button onClick={runBatch} disabled={batchRunning || selectedIds.length === 0}
                    style={{ padding: '8px 20px', border: 'none', borderRadius: 6, background: '#1890ff', color: '#fff', cursor: 'pointer', fontSize: 14, opacity: batchRunning ? 0.6 : 1 }}>
                    {batchRunning ? '执行中...' : `执行（${selectedIds.length} 笔）`}
                  </button>
                </div>
              </>
            ) : (
              <>
                <h3 style={{ margin: '0 0 12px', fontSize: 16 }}>✅ 批量发货结果</h3>
                <div style={{ fontSize: 13, marginBottom: 10 }}>
                  成功 <b style={{ color: '#52c41a' }}>{batchResult.shipped.length}</b> · 跳过 <b style={{ color: '#faad14' }}>{batchResult.skipped.length}</b> · 失败 <b style={{ color: '#ff4d4f' }}>{batchResult.failed.length}</b>
                </div>
                <div style={{ border: '1px solid #f0f0f0', borderRadius: 6, maxHeight: 260, overflowY: 'auto', padding: '8px 10px' }}>
                  {batchResult.shipped.map(s => (
                    <div key={'s' + s.id} style={{ color: '#52c41a', fontSize: 12, padding: '3px 0' }}>
                      ✅ #{s.id} {s.order_no || ''} → 已发货 · {s.tracking_no}
                    </div>
                  ))}
                  {batchResult.skipped.map(s => (
                    <div key={'k' + s.id} style={{ color: '#faad14', fontSize: 12, padding: '3px 0' }}>
                      ⏭️ #{s.id} {s.order_no || ''} — {s.reason}
                    </div>
                  ))}
                  {batchResult.failed.map(f => (
                    <div key={'f' + String(f.id)} style={{ color: '#ff4d4f', fontSize: 12, padding: '3px 0' }}>
                      ❌ #{f.id} — {f.reason}
                    </div>
                  ))}
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                  <button onClick={() => setBatchOpen(false)}
                    style={{ padding: '8px 20px', border: '1px solid #d9d9d9', borderRadius: 6, background: '#fff', cursor: 'pointer', fontSize: 14 }}>
                    关闭
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* 智能粘贴发货弹窗（P1-S · 2026-09-16） */}
      {smartOpen && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: 640, maxWidth: '94vw', maxHeight: '88vh', overflowY: 'auto' }}>
            {!smartResult ? (
              <>
                <h3 style={{ margin: '0 0 8px', fontSize: 16 }}>🪄 智能粘贴发货</h3>
                <div style={{ fontSize: 12, color: '#999', marginBottom: 12 }}>
                  把菜鸟导出的「收件人信息 + 物流信息」原文整块粘贴进来，系统自动按手机号/姓名/地址对单；确认后一键发货，无需先勾选订单。
                </div>
                <textarea value={smartText} onChange={e => setSmartText(e.target.value)} rows={9}
                  placeholder={'收件人信息：\n110.李雅，158****5678，浙江省杭州市钱塘区学林街清雅苑小区25幢三单元101室\n物流信息：\n【菜鸟】中通一联1，79033288100611\n…（可多单连贴）'}
                  style={{ width: '100%', boxSizing: 'border-box', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 13, fontFamily: 'monospace' }} />
                {smartError && <div style={{ marginTop: 8, fontSize: 12, color: '#ff4d4f' }}>❌ {smartError}</div>}
                <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 14 }}>
                  <button onClick={() => setSmartOpen(false)}
                    style={{ padding: '8px 20px', border: '1px solid #d9d9d9', borderRadius: 6, background: '#fff', cursor: 'pointer', fontSize: 14 }}>
                    取消
                  </button>
                  <button onClick={runSmartPreview} disabled={smartLoading}
                    style={{ padding: '8px 20px', border: 'none', borderRadius: 6, background: '#722ed1', color: '#fff', cursor: 'pointer', fontSize: 14, opacity: smartLoading ? 0.6 : 1 }}>
                    {smartLoading ? '解析中...' : '① 解析并对单'}
                  </button>
                </div>
                {smartPreview && (
                  <div style={{ marginTop: 16 }}>
                    <div style={{ fontSize: 13, marginBottom: 8 }}>
                      解析 {smartPreview.entries.length} 笔 ·
                      <span style={{ color: '#52c41a' }}> 精确 {smartPreview.summary.matched}</span> ·
                      <span style={{ color: '#fa8c16' }}> 存疑 {smartPreview.summary.ambiguous}</span> ·
                      <span style={{ color: '#ff4d4f' }}> 对不上 {smartPreview.summary.unmatched}</span>
                    </div>
                    <div style={{ border: '1px solid #f0f0f0', borderRadius: 6, maxHeight: 320, overflowY: 'auto' }}>
                      {smartPreview.entries.map(e => {
                        const p = smartPicks[e.idx] || { use: false, orderId: '', trackingNo: '' }
                        const tag = e.match === 'matched'
                          ? { t: '✅ ' + (e.confidence === 'high' ? '手机号全号精确' : e.confidence === 'address' ? '地址锚点精确' : '匹配到唯一订单'), c: '#52c41a' }
                          : e.match === 'ambiguous'
                            ? { t: '⚠️ 存疑：多个候选，请人工点选', c: '#fa8c16' }
                            : { t: '❌ 没对上：请人工指定订单或跳过', c: '#ff4d4f' }
                        return (
                          <div key={e.idx} style={{ padding: '10px 12px', borderBottom: '1px solid #f5f5f5', fontSize: 12 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, marginBottom: 6 }}>
                              <span style={{ fontWeight: 600 }}>{e.name || '（未识别姓名）'} <span style={{ color: '#999' }}>{e.phone}</span></span>
                              <span style={{ color: tag.c }}>{tag.t}</span>
                            </div>
                            <div style={{ color: '#999', marginBottom: 6, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              {e.address || '（无地址）'} · 运单 <b style={{ color: '#333' }}>{e.trackingNo || '缺失'}</b>
                            </div>
                            {e.match === 'ambiguous' && e.candidates.length > 0 && (
                              <select value={p.orderId} onChange={ev => updatePick(e.idx, 'orderId', ev.target.value)}
                                style={{ marginRight: 8, padding: '4px 8px', border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 12, maxWidth: 280 }}>
                                <option value="">— 选订单 —</option>
                                {e.candidates.map(c => (
                                  <option key={c.id} value={c.id}>#{c.id} {c.name} {c.product_name}（{c.order_no}）</option>
                                ))}
                              </select>
                            )}
                            {e.match === 'matched' && (
                              <span style={{ marginRight: 8, color: '#666' }}>→ #{e.order.id} {e.order.name}（{e.order.order_no}）</span>
                            )}
                            <label style={{ marginRight: 10, cursor: 'pointer' }}>
                              <input type="checkbox" checked={p.use} onChange={ev => updatePick(e.idx, 'use', ev.target.checked)} /> 发货
                            </label>
                            <input type="text" value={p.trackingNo} onChange={ev => updatePick(e.idx, 'trackingNo', ev.target.value)}
                              placeholder="运单号"
                              style={{ width: 150, padding: '4px 8px', border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 12, fontFamily: 'monospace' }} />
                          </div>
                        )
                      })}
                    </div>
                    <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 14 }}>
                      <span style={{ fontSize: 12, color: '#999', alignSelf: 'center' }}>将执行 {smartReadyCount()} 笔</span>
                      <button onClick={runSmartPreview} disabled={smartLoading}
                        style={{ padding: '8px 16px', border: '1px solid #722ed1', borderRadius: 6, background: '#fff', color: '#722ed1', cursor: 'pointer', fontSize: 13 }}>
                        重新解析
                      </button>
                      <button onClick={runSmartApply} disabled={smartRunning || smartReadyCount() === 0}
                        style={{ padding: '8px 20px', border: 'none', borderRadius: 6, background: smartReadyCount() ? '#52c41a' : '#d9d9d9', color: '#fff', cursor: smartReadyCount() ? 'pointer' : 'not-allowed', fontSize: 14, opacity: smartRunning ? 0.6 : 1 }}>
                        {smartRunning ? '执行中...' : `② 确认发货（${smartReadyCount()} 笔）`}
                      </button>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <>
                <h3 style={{ margin: '0 0 12px', fontSize: 16 }}>✅ 智能发货结果</h3>
                <div style={{ fontSize: 13, marginBottom: 10 }}>
                  成功 <b style={{ color: '#52c41a' }}>{smartResult.shipped.length}</b> · 跳过 <b style={{ color: '#faad14' }}>{smartResult.skipped.length}</b> · 失败 <b style={{ color: '#ff4d4f' }}>{smartResult.failed.length}</b>
                </div>
                <div style={{ border: '1px solid #f0f0f0', borderRadius: 6, maxHeight: 280, overflowY: 'auto', padding: '8px 10px' }}>
                  {smartResult.shipped.map(s => (
                    <div key={'s' + s.id} style={{ color: '#52c41a', fontSize: 12, padding: '3px 0' }}>
                      ✅ #{s.id} {s.order_no || ''} {s.name || ''} → 已发货 · {s.tracking_no}
                    </div>
                  ))}
                  {smartResult.skipped.map(s => (
                    <div key={'k' + s.id} style={{ color: '#faad14', fontSize: 12, padding: '3px 0' }}>
                      ⏭️ #{s.id} — {s.reason}
                    </div>
                  ))}
                  {smartResult.failed.map(f => (
                    <div key={'f' + String(f.id)} style={{ color: '#ff4d4f', fontSize: 12, padding: '3px 0' }}>
                      ❌ #{String(f.id)} — {f.reason}
                    </div>
                  ))}
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                  <button onClick={() => setSmartOpen(false)}
                    style={{ padding: '8px 20px', border: '1px solid #d9d9d9', borderRadius: 6, background: '#fff', cursor: 'pointer', fontSize: 14 }}>
                    关闭
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* 物流编辑弹窗 */}
      {editingDelivery && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: 420, maxWidth: '90vw' }}>
            <h3 style={{ margin: '0 0 20px', fontSize: 16 }}>📦 物流管理</h3>
            
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 13, color: '#666', marginBottom: 6 }}>物流状态</label>
              <select value={editingDelivery.deliveryStatus}
                onChange={e => updateDeliveryField('deliveryStatus', e.target.value)}
                style={{ width: '100%', padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }}>
                {DELIVERY_STATUS_OPTIONS.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>

            <div style={{ marginBottom: 24 }}>
              <label style={{ display: 'block', fontSize: 13, color: '#666', marginBottom: 6 }}>快递单号</label>
              <input type="text" value={editingDelivery.trackingNo}
                onChange={e => updateDeliveryField('trackingNo', e.target.value)}
                placeholder="请输入快递单号"
                style={{ width: '100%', padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' }} />
            </div>

            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
              <button onClick={() => setEditingDelivery(null)}
                style={{ padding: '8px 20px', border: '1px solid #d9d9d9', borderRadius: 6, background: '#fff', cursor: 'pointer', fontSize: 14 }}>
                取消
              </button>
              <button onClick={saveDelivery} disabled={saving}
                style={{ padding: '8px 20px', border: 'none', borderRadius: 6, background: '#1890ff', color: '#fff', cursor: 'pointer', fontSize: 14, opacity: saving ? 0.6 : 1 }}>
                {saving ? '保存中...' : '保存'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
